// deps
import React, { memo } from "react";
import cx from "classnames";

// internal deps
import { AriaHidden, format } from "@swiggy-private/core-ui";

// components
import { TickIcon } from "@super-ui/widgets/tick-icon";

// interfaces
import { OneBenefit } from "@super-ui/interfaces/SwiggyOne";

// constants
import { ONE_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { UX4_PRIMARY_ORANGE } from "@super-ui/constants/Color";

import styles from "../styles/Benefits.v4.scss";

interface BenefitItemProps {
    benefit: OneBenefit;
    idx: number;
    isOneLitePlan?: boolean;
    color?: string;
}
const BenefitItem: React.FC<BenefitItemProps> = ({ benefit, idx, isOneLitePlan = false }: BenefitItemProps) => {
    const dataTestId = format(ONE_WIDGET_TEST_IDS.BENEFITS_LIST_ITEM, String(idx));
    const benefitItemClass = cx({
        [styles.benefitItem]: true,
        [styles.benefitItemLite]: isOneLitePlan,
    });

    return (
        <AriaHidden as="div" className={benefitItemClass} data-testid={dataTestId}>
            <TickIcon className={styles.benefitTickIcon} color={benefit.color ? benefit.color : UX4_PRIMARY_ORANGE} />
            <span
                className={cx(styles.benefitItemTitle, {
                    [styles.benefitItemTitleShimmer]: benefit.show_shimmer,
                    [styles.benefitItemTitleLite]: isOneLitePlan,
                })}
            >
                {benefit.title}
            </span>

            <span
                className={benefit.applyCustomClass ? styles.benefitItemDoSubTitle : styles.benefitItemSubTitle}
                dangerouslySetInnerHTML={{ __html: benefit.sub_title }}
            />
        </AriaHidden>
    );
};

export default memo(BenefitItem);
